import { render } from "./Operate.vue?vue&type=template&id=37c918f0&scoped=true"
import script from "./Operate.vue?vue&type=script&lang=js"
export * from "./Operate.vue?vue&type=script&lang=js"

import "./Operate.vue?vue&type=style&index=0&id=37c918f0&scoped=true&lang=css"

import exportComponent from "/home/runner/work/bomoindustrial-vue/bomoindustrial-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-37c918f0"]])

export default __exports__